import React, { useEffect } from "react";
import { gapi } from "gapi-script";
import { GoogleLogin } from "react-google-login";
import { GOOGLE_OAUTH_CLIENT_ID } from "../../config/index";
import { Button } from "react-bootstrap";
import { useGoogleLogin, useSetUserDetails } from "./store/store";
import { useToast } from "modules/navbar/top/store/toasterStore";

const LoginWithGoogle = () => {
  const { setToaster } = useToast();
  const { googleLogin } = useGoogleLogin();
  const { setUserDetails } = useSetUserDetails();
  

  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: GOOGLE_OAUTH_CLIENT_ID,
        scope: "",
      });
    };
    gapi.load("client:auth2", initClient);
  });

  const handleSuccess = async (google_response) => {
    googleLogin(google_response, setToaster, setUserDetails);
  };

  const handleFailure = (google_response) => {};

  return (
    <GoogleLogin
      clientId={GOOGLE_OAUTH_CLIENT_ID}
      cookiePolicy="single_host_origin"
      isSignedIn={false}
      onFailure={handleFailure}
      onSuccess={handleSuccess}
      render={(renderProps) => (
        <Button disabled={renderProps.disabled} onClick={renderProps.onClick}>
          Sign in with Google
        </Button>
      )}
    />
  );
};

export default LoginWithGoogle;
